import DefaultFormSubtitle from "./DefaultFormSubtitle";
import generateRender from 'shared/utils/generateRender';

const FormSubtitle = generateRender({
    default: DefaultFormSubtitle,
})

export default FormSubtitle;